import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const TypeEditorWidget: WidgetRegistryEntry = {
  name: "TypeEditor",
  component: () => import("./type-editor-widget.component").then((m) => m.TypeEditorWidgetComponent),
  configuration: () => import("./configuration").then((m) => m.TypeEditorWidgetConfiguration)
};
